document.addEventListener('DOMContentLoaded', function() {
    function removeShogunAccordionActive() {
        if (window.innerWidth < 1200 && document.querySelector('.mobile-fixed')) {
            const activeAccordions = document.querySelectorAll('.shogun-accordion-active');
            activeAccordions.forEach(function(accordion) {
                accordion.classList.remove('shogun-accordion-active');
            });
        }
    }

    removeShogunAccordionActive();
}); 